const format_date_yyyy_mm_dd = (date) => {
	date = new Date(date)
	const yyyy = date.getFullYear();
	const mm = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
	const dd = String(date.getDate()).padStart(2, '0');
	return `${yyyy}-${mm}-${dd}`;
}

export default format_date_yyyy_mm_dd